import React from 'react';
import { Image } from '../../elements/Image'
import { Icon } from '../../elements/Icon';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { MinSidebarMenu } from './minSideBarMenu/MinSidebarMenu';

export const VerticalMenuItem = ({ image, url, typeIcon, active, handlerClick, id, tooltip, link, className, menu }) => {

    let styleClass = "";
    if (active) {
        styleClass = " menuLink active";
    } else {
        styleClass = " menuLink ";
    }

    const idSideBarMenu = menu ? `${id}Menu` : undefined;
    const contentMenu = menu?.content;
    const titleMenu = menu?.text;
    const clicMenu = menu?.clicMenu;
    const showMinSideMenu = menu?.showMenu !== undefined && menu?.showMenu !== null ? menu?.showMenu :  active;

    return (
        <>
        {image ? 
            <>
            {link !== null ? 
            <Link id={id} to={link ? link : '#'} onClick={handlerClick} className={className}>
                <div id={id} className="logo_content">
                    <div className="logo">
                        <Image url={url} title={"iProveedor"} width={"40px"} height={"40px"}/>
                    </div>
                </div>
            </Link>
            :
            <div id={id} className={`logo_content ${className}`}>
                <div className={"logo_content"}>
                    <Image url={url} title={"iProveedor"} width={"40px"} height={"40px"}/>
                </div>
            </div>
            }
            </>
            :
            // rome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
            <li onClick={handlerClick} className={className}>
                <div className='itemContent'>
                    {link !== null ?
                    <Link id={id} to={link ? link : '#'}  className={styleClass}>
                        <Icon typeIcon={typeIcon} />
                        <span className="links_name" />
                    </Link>
                    : <div id={id} className={`link ${styleClass}`}>
                        <Icon typeIcon={typeIcon} />
                        <span className="links_name" />
                    </div>
                    }
                    {tooltip && <span className="tooltip">{tooltip}</span>}
                </div>
                {menu &&
                <MinSidebarMenu id={idSideBarMenu} showClient={showMinSideMenu} contentComp={contentMenu} name={titleMenu} clicMenu={clicMenu}/>}
            </li>}
        </>

    );

};

VerticalMenuItem.propTypes = {
    image: PropTypes.bool,
    url: PropTypes.string,
    typeIcon: PropTypes.string,
    active: PropTypes.bool,
    handlerClick: PropTypes.func,
    id: PropTypes.string.isRequired,
    class : PropTypes.string
};